// Add.jsx
import React, { useState } from "react";
import axiosInstance from "../../../../utils/axiosConfig";
import { useSelector } from "react-redux";

const Add = ({ title, fields, apiEndpoint, onClose, onSuccess }) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {})
  );
  const [error, setError] = useState("");

  const handleChange = (field, value) => {
    // First update the form data with the new value
    setFormData((prev) => ({ ...prev, [field]: value }));
    
    // If the field is LHead (Location Head), find the selected user's email and auto-fill LocationEmail
    if (field === "LHead") {
      const locationHeadField = fields.find(f => f.name === "LHead");
      if (locationHeadField && locationHeadField.options) {
        const selectedUser = locationHeadField.options.find(opt => opt.value === value);
        if (selectedUser && selectedUser.email) {
          // Use setTimeout to ensure the state update happens after the current render cycle
          setTimeout(() => {
            setFormData(prev => ({ ...prev, LocationEmail: selectedUser.email }));
          }, 0);
        }
      }
    }
  };

  const enteredBy = useSelector((state) => state.auth.id);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const currentUser = enteredBy;
      await axiosInstance.post(apiEndpoint, { ...formData, EnteredBy: currentUser });
      onSuccess();
      onClose();
    } catch (err) {
      setError("Failed to add item. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded shadow-lg w-full max-w-md mx-4">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        {error && <p className="text-red-500 mb-2">{error}</p>}
        <form onSubmit={handleSubmit}>
          {fields.map((field) => (
            <div key={field.name} className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {field.label}
              </label>
              {field.type === "select" ? (
                <select
                  value={formData[field.name]}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                  required={field.required}
                >
                  <option value="">Select {field.label}</option>
                  {field.options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type || "text"}
                  value={formData[field.name]}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  className="w-full px-3 py-2 border rounded"
                  required={field.required}
                />
              )}
            </div>
          ))}
          <div className="flex flex-col sm:flex-row justify-end gap-4">
            <button
              type="button"
              onClick={onClose}
              className="w-full sm:w-auto px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 mb-2 sm:mb-0"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;